import { render, staticRenderFns } from "./SettingRow.vue?vue&type=template&id=bf95218e"
import script from "./SettingRow.vue?vue&type=script&lang=js"
export * from "./SettingRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports